var Main;
(function (Main) {
    const win = window;
    let lastSignalRUpdate;
    Main.baseChatRoomGUID = "a9529246-4dea-4784-a43a-1805f404f542";
    function UseMetric() {
        if (win.cobra.serverBuild === "Belgium") {
            return true;
        }
        if (win.cobra.cultureName !== "en-US") {
            return true;
        }
        return false;
    }
    Main.UseMetric = UseMetric;
    function draggableOnDragStart(e) {
        $(e.currentTarget).addClass("dragging");
        $(".dropable").removeClass("dropping");
    }
    Main.draggableOnDragStart = draggableOnDragStart;
    function draggableOnDragEnd(e) {
        $(e.currentTarget).removeClass("dragging");
    }
    Main.draggableOnDragEnd = draggableOnDragEnd;
    function droptargetOnDragEnter(e) {
        $(e.dropTarget).addClass("dropping");
    }
    Main.droptargetOnDragEnter = droptargetOnDragEnter;
    function droptargetOnDragLeave(e) {
        $(e.dropTarget).removeClass("dropping");
    }
    Main.droptargetOnDragLeave = droptargetOnDragLeave;
    function GenerateDragAndDropWidget(element, gridID) {
        const uid = element.attr("data-uid");
        const dataItem = $("#" + gridID)
            .data("kendoGrid")
            .dataSource.getByUid(uid);
        const item = $('<div class="k-grid k-widget" style="background-color: DarkOrange; color: black; width: 50%;"><table><tbody><tr>' +
            element.html() +
            "</tr></tbody></table></div>");
        element.attr("id", dataItem.id);
        return item;
    }
    Main.GenerateDragAndDropWidget = GenerateDragAndDropWidget;
    function initKendoCulture(cultureToInit) {
        kendo.culture(cultureToInit);
        $.validator.addMethod("date", function (value, element) {
            return this.optional(element) || kendo.parseDate(value);
        });
    }
    Main.initKendoCulture = initKendoCulture;
    function SetGridFilterSettingsOnOpen(e) {
        const con0 = e.container.find('[data-bind="value: filters[0].operator"]');
        if (con0) {
            let dropDown0 = con0.data("kendoDropDownList");
            if (dropDown0 &&
                dropDown0.dataSource &&
                dropDown0.dataSource.options.data.filter((p) => p.value === "contains").length !== 0) {
                con0.data("kendoDropDownList").value("contains");
            }
        }
        const chng0 = e.container.find('[data-bind="value: filters[0].operator"]');
        if (chng0 && chng0.data("kendoDropDownList")) {
            chng0.data("kendoDropDownList").trigger("change");
        }
        const con1 = e.container.find('[data-bind="value: filters[1].operator"]');
        if (con1) {
            let dropDown1 = con1.data("kendoDropDownList");
            if (dropDown1 &&
                dropDown1.dataSource &&
                dropDown1.dataSource.options.data.filter((p) => p.value === "contains").length !== 0) {
                con1.data("kendoDropDownList").value("contains");
            }
        }
        const chng1 = e.container.find('[data-bind="value: filters[1].operator"]');
        if (chng1 && chng1.data("kendoDropDownList")) {
            chng1.data("kendoDropDownList").trigger("change");
        }
    }
    Main.SetGridFilterSettingsOnOpen = SetGridFilterSettingsOnOpen;
    function cleanExcelText() {
        const element = document.querySelector(".k-grid-excel");
        element.innerHTML = element.innerHTML.replace(element.innerText, "&nbsp;&nbsp;" + element.innerText);
    }
    Main.cleanExcelText = cleanExcelText;
    function dateFormatter(datetouse) {
        const dateToCheck = new Date(datetouse).setHours(0, 0, 0, 0);
        const todaysDate = new Date().setHours(0, 0, 0, 0);
        if (dateToCheck === todaysDate) {
            return kendo.toString(datetouse, "T");
        }
        else {
            return kendo.toString(datetouse, "G");
        }
    }
    Main.dateFormatter = dateFormatter;
    function ExcelExportFormateColForDateTime(colIndex, excel) {
        let cellFormat = "MM-dd-yyyy hh:mm:ss";
        const twoLetterLang = win.cobra.cultureName.substring(0, 2);
        switch (twoLetterLang) {
            case "en":
                switch (win.cobra.cultureName) {
                    case "en-GB":
                        cellFormat = "dd/MM/yyyy hh:mm:ss";
                        break;
                    case "en-US":
                        cellFormat = "MM/dd/yyyy hh:mm:ss";
                        break;
                }
                break;
            case "jp":
            case "ja":
                cellFormat = "yyyy/MM/dd HH:mm:ss";
                break;
            case "fr":
            case "nl":
            case "de":
            case "ar":
            case "pt":
            case "tr":
                cellFormat = "dd/MM/yyyy hh:mm:ss";
                break;
            default:
                cellFormat = "MM/dd/yyyy hh:mm:ss";
                break;
        }
        excel.workbook.sheets[0].columns[colIndex].width = 150;
        for (let i = 1; i < excel.workbook.sheets[0].rows.length; i++) {
            excel.workbook.sheets[0].rows[i].cells[colIndex].format = cellFormat;
        }
    }
    Main.ExcelExportFormateColForDateTime = ExcelExportFormateColForDateTime;
    function ClearTreeSelection(treeGridID) {
        const treeView = $(treeGridID).data("kendoTreeList");
        treeView.select($());
    }
    Main.ClearTreeSelection = ClearTreeSelection;
    function clearKendoUpload(uploadToClear) {
        if (uploadToClear !== null && uploadToClear !== undefined && uploadToClear.length > 0) {
            $("#" + uploadToClear + " .k-upload-files").remove();
            $("#" + uploadToClear)
                .closest(".input-group")
                .find(".k-file")
                .remove();
            $("#" + uploadToClear + " .k-upload-status").remove();
            $("#" + uploadToClear)
                .closest(".input-group")
                .find(".k-upload-status")
                .remove();
            $("#" + uploadToClear + " .k-upload.k-header").addClass("k-upload-empty");
            $("#" + uploadToClear)
                .closest(".input-group")
                .find(".k-upload.k-header")
                .addClass("k-upload-empty");
            $("#" + uploadToClear + " .k-upload-button").removeClass("k-state-focused");
            $("#" + uploadToClear)
                .closest(".k-upload-button")
                .find(".k-upload.k-header")
                .removeClass("k-state-focused");
        }
        else {
            $(".k-upload-files").remove();
            $(".k-upload-status").remove();
            $(".k-upload.k-header").addClass("k-upload-empty");
            $(".k-upload-button").removeClass("k-state-focused");
        }
    }
    Main.clearKendoUpload = clearKendoUpload;
    function updateKendoDateTimePickerToLocal(formSubmit, kendoID, unixSource) {
        const dateStorage = document.getElementById(unixSource);
        if (dateStorage) {
            const formField = $("#" + formSubmit);
            if (formField) {
                const value = dateStorage.dateTime;
                if (value) {
                    const momentUTC = win.globalMoment.unix(value);
                    $("#" + kendoID)
                        .data("kendoDateTimePicker")
                        .value(momentUTC.local().toDate());
                    formField.val(momentUTC.utc().toISOString());
                }
            }
        }
    }
    Main.updateKendoDateTimePickerToLocal = updateKendoDateTimePickerToLocal;
    function onKendoTimePickerChange() {
        const value = this.value();
        let dateFieldId = "";
        if (this.element && this.element[0]) {
            dateFieldId = this.element[0].getAttribute("data-dateFieldId");
        }
        if (value !== null && value !== undefined && dateFieldId != null && dateFieldId !== undefined) {
            const momentObj = window.globalMoment.utc(value.getTime());
            $("#" + dateFieldId).val(momentObj.utc().toISOString());
        }
        else {
            $("#" + dateFieldId).val(null);
        }
    }
    Main.onKendoTimePickerChange = onKendoTimePickerChange;
    function textFormatter(text, maxlength) {
        if (text && text.length > maxlength) {
            return (text.substring(0, maxlength) +
                "&nbsp;<i class='fas fa-ellipsis-h' data-fa-transform='down-5' title='" +
                htmlEncode(text) +
                "'></i>");
        }
        else {
            return htmlEncode(text);
        }
    }
    Main.textFormatter = textFormatter;
    function initgoogmap() {
    }
    Main.initgoogmap = initgoogmap;
    function checkNull(val) {
        if (val === null) {
            return "";
        }
        else {
            return val;
        }
    }
    Main.checkNull = checkNull;
    function filterStateList() {
        return {
            CountryCode: $("#Country").val(),
        };
    }
    Main.filterStateList = filterStateList;
    function htmlEncode(html) {
        const doc = document.createElement("div");
        doc.textContent = html;
        if (!doc.textContent.includes("\\")) {
            return doc.textContent;
        }
        else {
            doc.textContent = doc.textContent.replace(/\\/g, "");
            return doc.textContent;
        }
    }
    Main.htmlEncode = htmlEncode;
    function parseLogLinks(logGUIDs) {
        let ret = "";
        if (logGUIDs !== null && logGUIDs.length > 0) {
            for (let x = 0; x < logGUIDs.length; x++) {
                const linkURL = currentUrlPrefix() +
                    "Incident/IncidentHome/GetToolLinkURL/" +
                    win.cobra.project.id +
                    "?logGUID=" +
                    logGUIDs[x];
                ret =
                    ret +
                        "<sup><a class='btn btn-link btn-sm' title='Click to view associated entry' href='" +
                        linkURL +
                        "' target='_blank' rel='noopener noreferrer'><span class='fa fa-link'></span></a></sup>";
            }
        }
        return ret;
    }
    Main.parseLogLinks = parseLogLinks;
    function showIsPagingChecked() {
        if ($("#ispaging").is(":checked")) {
            return true;
        }
        else {
            return false;
        }
    }
    function markObjectAsError(inputObject) {
        if (inputObject !== null) {
            inputObject.addClass("input-validation-error");
            inputObject.attr("aria-describedby", inputObject.name + "-error");
            inputObject.attr("aria-required", "true");
        }
    }
    Main.markObjectAsError = markObjectAsError;
    function clearObjectErrorStatus(inputObject) {
        if (inputObject !== null) {
            inputObject.removeClass("input-validation-error");
            inputObject.removeAttr("aria-describedby");
        }
    }
    Main.clearObjectErrorStatus = clearObjectErrorStatus;
    function htmlEscape(str) {
        return str
            .replace(/&/g, "&amp;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;");
    }
    Main.htmlEscape = htmlEscape;
    function stripHtml(str) {
        return str.replace(/<((table|tbody|tr|td|img)|(\/table|\/tbody|\/tr|\/td|\/img)).*?>|&nbsp;/g, "");
    }
    Main.stripHtml = stripHtml;
    function htmlUnescape(str) {
        const tmp = document.createElement("htmlStrip");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }
    Main.htmlUnescape = htmlUnescape;
    function validatePhoneNumber(str) {
        return /^((?:\+|00)[17](?: |\-)?|(?:\+|00)[0-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[0-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))$/g.test(str);
    }
    Main.validatePhoneNumber = validatePhoneNumber;
    function validateEmailAddr(str) {
        return /^[A-Za-z0-9!#$%&'*’+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%’&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/g.test(str);
    }
    Main.validateEmailAddr = validateEmailAddr;
    function resizeAllTextAreas() {
        $("textarea").each(function () {
            resizeSpecificTextArea(this);
        });
    }
    Main.resizeAllTextAreas = resizeAllTextAreas;
    function resizeSpecificTextArea(ta) {
        if (!ta) {
            return;
        }
        if (ta.clientHeight === ta.scrollHeight) {
            ta.style.height = "30px";
        }
        const maxHeight = null;
        let adjustedHeight = ta.clientHeight;
        if (!maxHeight || maxHeight > adjustedHeight) {
            adjustedHeight = Math.max(ta.scrollHeight, adjustedHeight) + 30;
            if (maxHeight) {
                adjustedHeight = Math.min(maxHeight, adjustedHeight);
            }
            if (adjustedHeight > ta.clientHeight) {
                ta.style.height = adjustedHeight + "px";
            }
        }
    }
    function changeNewLine(text) {
        const regexp1 = new RegExp("\r\n", "g");
        const regexp2 = new RegExp("\n", "g");
        if (text) {
            text = text.replace(regexp1, "<br/>");
            text = text.replace(regexp2, "<br/>");
        }
        else {
            text = "";
        }
        return text;
    }
    Main.changeNewLine = changeNewLine;
    function IsValidJsonString(str) {
        if (str === undefined || str === null || str.length === 0) {
            return false;
        }
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    }
    Main.IsValidJsonString = IsValidJsonString;
    function selectedorgchanged(currentOrg, newOrg) {
        const currentURL = window.location.pathname;
        let urlToPost = "";
        if (currentURL.toLowerCase().indexOf("currentorganization") >= 0) {
            urlToPost = currentURL.replace(currentOrg, newOrg);
        }
        else if (currentURL.toLowerCase().indexOf("?") >= 0) {
            urlToPost = currentURL + "&CurrentOrganization=" + newOrg;
        }
        else {
            urlToPost = currentURL + "?CurrentOrganization=" + newOrg;
        }
        window.location.href = urlToPost;
    }
    Main.selectedorgchanged = selectedorgchanged;
    function checkConsent() {
        const prefix = currentUrlPrefix();
        if (prefix !== null && prefix !== undefined) {
            const newurl = prefix + "Account/SeeIfConsentBannerIsRequired";
            $.ajax({
                url: newurl,
                type: "GET",
                cache: true,
                success: (checkResponse) => {
                    if (checkResponse && checkResponse.BannerExists) {
                        if (checkResponse.Banner && checkResponse.Banner.length > 0) {
                            $("#divConsent").html(checkResponse.Banner);
                            $("#consentModal").modal({ keyboard: false, backdrop: "static" });
                            document.getElementById("btnConsentOk").focus();
                        }
                    }
                },
                error: (xhr, status, error) => {
                    window.cobra.handlejqerr(xhr, status, error);
                },
            });
        }
    }
    Main.checkConsent = checkConsent;
    function wasLastUpdateTooRecent() {
        const refreshTimeMaxInSeconds = 5;
        const curTime = window.globalMoment();
        if (lastSignalRUpdate !== null && lastSignalRUpdate !== undefined) {
            const diffValue = curTime.diff(lastSignalRUpdate, "seconds");
            if (diffValue < refreshTimeMaxInSeconds) {
                return true;
            }
        }
        lastSignalRUpdate = curTime;
        return false;
    }
    Main.wasLastUpdateTooRecent = wasLastUpdateTooRecent;
})(Main || (Main = {}));

//# sourceMappingURL=Main.js.map
